var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17139 0.714287C2.39419 0.714287 0.142822 2.96565 0.142822 5.74286V23.3429C0.142822 26.1201 2.39419 28.3714 5.17139 28.3714H8.94282C9.63712 28.3714 10.2 27.8086 10.2 27.1143C10.2 26.42 9.63712 25.8571 8.94282 25.8571H5.17139C3.78279 25.8571 2.65711 24.7315 2.65711 23.3429V5.74286C2.65711 4.35426 3.78279 3.22857 5.17139 3.22857H32.8285C34.2171 3.22857 35.3428 4.35426 35.3428 5.74286V23.3429C35.3428 24.7315 34.2171 25.8571 32.8285 25.8571H18.621C16.8547 25.8571 15.2178 26.7839 14.3091 28.2985L11.6363 32.7532C11.279 33.3486 11.4721 34.1208 12.0675 34.478C12.6628 34.8352 13.435 34.6422 13.7922 34.0468L16.465 29.5921C16.9194 28.8348 17.7379 28.3714 18.621 28.3714H32.8285C35.6057 28.3714 37.8571 26.1201 37.8571 23.3429V5.74286C37.8571 2.96566 35.6057 0.714287 32.8285 0.714287H5.17139ZM14.6 15.1715C14.6 14.1301 13.7558 13.2858 12.7143 13.2858C11.6729 13.2858 10.8286 14.1301 10.8286 15.1715C10.8286 16.213 11.6729 17.0572 12.7143 17.0572C13.7558 17.0572 14.6 16.213 14.6 15.1715ZM20.8858 15.1715C20.8858 14.1301 20.0415 13.2858 19 13.2858C17.9586 13.2858 17.1143 14.1301 17.1143 15.1715C17.1143 16.213 17.9586 17.0572 19 17.0572C20.0415 17.0572 20.8858 16.213 20.8858 15.1715ZM27.1715 15.1715C27.1715 14.1301 26.3272 13.2858 25.2858 13.2858C24.2443 13.2858 23.4 14.1301 23.4 15.1715C23.4 16.213 24.2443 17.0572 25.2858 17.0572C26.3272 17.0572 27.1715 16.213 27.1715 15.1715Z",
    fill: "url(#paint0_linear_2387_1246)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2387_1246",
    x1: 25.7937,
    y1: -54.053,
    x2: -17.2429,
    y2: 12.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065984,
    stopColor: "#87BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005FC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.98332c5c.svg";
export { ForwardRef as ReactComponent };